const showTableDataByValue = (table, column, value) => {
  if (!table) throw Error('No table found');

  const tableRows = [...table.querySelectorAll('tr')];

  tableRows.forEach((row) => {
    const cells = row.querySelectorAll('td')[column];
    const data = [...cells.querySelectorAll('.table_data > *')];
    const filteredCells = data.filter((item) => !Object.hasOwn(item.dataset, value));

    data.forEach((item) => item.classList.remove('hidden'));
    filteredCells.forEach((item) => item.classList.add('hidden'));
  });
};

export default showTableDataByValue;
